module.exports = __webpack_public_path__ + "img/statistic.5cd33737.png";